import { makeStyles } from '@fluentui/react-components';
export var useCarouselListDefaultStyles = makeStyles({
    container: {
        width: '100%',
        display: 'flex',
    },
    item: {
        position: 'relative',
    },
});
//# sourceMappingURL=CarouselListDefault.styles.js.map